export default "__VITE_ASSET__CoG5C3Kx__"